import React, { memo, Fragment } from 'react';
import { string, func, shape, arrayOf } from 'prop-types';

import ActiveFilter from './ActiveFilter';

const ActiveFilters = ({
    activeFilters,
    clearFiltersButtonTitle,
    clearFilterTitle,
    handleClearFilters,
    onCheckboxChange,
    onResetSelect
}) => {
    const renderActiveFilterByType = activeFilter => {
        switch (activeFilter.type) {
            case 'checkbox':
                return (
                    <Fragment key={activeFilter.id}>
                        {!!activeFilter.options &&
                            !!activeFilter.options.length &&
                            activeFilter.options.map(option => (
                                <ActiveFilter
                                    clearFilterTitle={clearFilterTitle}
                                    key={option.id}
                                    onClearClick={() =>
                                        onCheckboxChange(
                                            option.id,
                                            activeFilter.id
                                        )
                                    }
                                    title={option.label}
                                />
                            ))}
                    </Fragment>
                );

            case 'select': {
                return (
                    <Fragment key={activeFilter.id}>
                        {!!activeFilter.options &&
                            !!activeFilter.options.length && (
                                <ActiveFilter
                                    clearFilterTitle={clearFilterTitle}
                                    onClearClick={() => {
                                        if (onResetSelect) {
                                            onResetSelect(activeFilter.id);
                                        }
                                    }}
                                    title={activeFilter.options[0].label}
                                />
                            )}
                    </Fragment>
                );
            }

            default:
                return null;
        }
    };

    if (!activeFilters || !activeFilters.length) {
        return null;
    }

    return (
        <div className="listing-active-filters">
            {clearFiltersButtonTitle && handleClearFilters && (
                <div className="listing-active-filters__clear-filters">
                    <button
                        className="link link--no-arrow"
                        onClick={handleClearFilters}
                        type="button"
                    >
                        {clearFiltersButtonTitle}
                    </button>
                </div>
            )}
            <div className="listing-active-filters__filters">
                <div className="listing-active-filters__row">
                    {activeFilters.map(renderActiveFilterByType)}
                </div>
            </div>
        </div>
    );
};

ActiveFilters.propTypes = {
    activeFilters: arrayOf(shape({})).isRequired,
    clearFiltersButtonTitle: string,
    clearFilterTitle: string.isRequired,
    handleClearFilters: func,
    onCheckboxChange: func.isRequired,
    onResetSelect: func
};

export default memo(ActiveFilters);
